import { useState } from 'react';
import { useDispatch } from 'react-redux';

import Modal from '../../../../common/components/Modal';
import { useGoogleAnalytics } from '../../../../common/hooks/useGoogleAnalytics';
import useRequestRedwolfService from '../../../../common/hooks/useRequestRedwolfService';
import useTechnicalErrorMessage from '../../../../common/hooks/useTechnicalErrorMessage';
import * as Sentry from '@sentry/react';
import { authAPI } from '../../../../../services/redwolfSdkAPI';
import { openNotification } from '../../../../../store/commonSlice';
import { notification } from '../../../../../utils/constants';
import Spinner from '../../../../common/components/Spinner';
import { getToken } from '../../../../../utils/localStorage';

interface UnregisterProductProps {
	isUnregisterDeviceInfoModalOpen: boolean;
	getRegisterProductList: () => void;
	serialNumber: string;
	handleModalUnregisterClose: () => void;
}

const UnregisterProduct = ({
	isUnregisterDeviceInfoModalOpen,
	getRegisterProductList,
	serialNumber,
	handleModalUnregisterClose
}: UnregisterProductProps) => {
	const [isSpinnerLoading, setIsSpinnerLoading] = useState(false);
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();
	const [logGoogleAnalyticsEvent] = useGoogleAnalytics();
	const dispatch = useDispatch();
	const [requestRedwolfService] = useRequestRedwolfService();
	const token = getToken();

	const transaction = Sentry.startInactiveSpan({ name: 'Unregister Product' });

	const removeRegisteredProduct = (event: any) => {
		event.preventDefault();
		logGoogleAnalyticsEvent('VIZIO_ACCOUNT_WEB_UNREGISTER');
		setIsSpinnerLoading(true);

		requestRedwolfService(authAPI.unregisterProduct(token, serialNumber))
			.then((response: any) => {
				if (response.constructor.$metadata$.simpleName === 'Success') {
					dispatch(
						openNotification({
							type: 'SUCCESS',
							heading: 'Success',
							body: notification.message.unRegisterProductSuccess
						})
					);
					getRegisterProductList();
					logGoogleAnalyticsEvent('VIZIO_ACCOUNT_WEB_UNREGISTER_PRODUCT_SUCCESS');
					handleModalUnregisterClose();
				} else {
					showTechnicalErrorMessage();

					Sentry.captureException(new Error('unregisterProduct' + response));
					logGoogleAnalyticsEvent('VIZIO_ACCOUNT_WEB_UNREGISTER_PRODUCT_FAILURE', {
						error: response.constructor.$metadata$.simpleName
					});
				}
				setIsSpinnerLoading(false);
				transaction && transaction.end();
			})
			.catch((err: any) => {
				handleModalUnregisterClose();
				transaction && transaction.end();
				setIsSpinnerLoading(false);
				showTechnicalErrorMessage();
				Sentry.captureException(err);
				logGoogleAnalyticsEvent('VIZIO_ACCOUNT_WEB_UNREGISTER_PRODUCT_FAILURE', { error: err });
			});
	};

	return (
		<>
			<Modal
				containerId="unregisterDevice"
				overlaycontainerClass="unregister_divice"
				show={isUnregisterDeviceInfoModalOpen}
				onHide={() => handleModalUnregisterClose()}
				heading="Unregister your device"
				containerClasses="support-modal">
				<form className="edit-modal-form" id="unregister-products">
					<div className="removesubheadbottom">
						<p>Remove registered device from VIZIO Account.</p>
					</div>
					<div className="form-field content-right">
						<button
							type="submit"
							className="primary-button"
							id="unregister-product-reg"
							onClick={removeRegisteredProduct}>
							Unregister
						</button>
					</div>
				</form>
			</Modal>
			{isSpinnerLoading && <Spinner />}
		</>
	);
};

export default UnregisterProduct;
